<div style="position: relative; min-height: 20rem">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div class="c-portlet_box_specs">
		<div
			class="c-portlet__header o-stack o-stack--center o-stack--splitted u-px-small u-py-mini c-portlet-gap primary-color-bg"
		>
			<div class="o-stack__cell">
				<h5>
					{{ sectiontitle }}
					<span *ngIf="hasData">
						<a
							href="javascript:void(0)"
							class="datatable_download_icon"
							(click)="downloadCSV()"
							*ngIf="downloadConfiguration && downloadConfiguration.enableDownload"
						>
							<img class="downloadIcon" src="{{ downloadIcon }}" />
						</a>
					</span>
				</h5>
			</div>
		</div>
		<div >
			<div class="o-stack o-stack--nowrap o-stack--center">
				<div class="devices-wrapper conversion-wrapper">
					<div class="donut-chart-container">
						<div >
							<div  *ngIf="hasData" class="metrics-header">
								<div class="sem-conversion-metrics" *ngFor="let metric of metricObject">
									<div class="conversion-metrics">
										<div class="metric-value" appTooltip [attr.title]="metric?.tooltip" data-size="small" [options]="tooltipOptions">
											{{ metric.value }}
										</div>
										<div class="metric-name">
											{{ metric.name }}
										</div>
									</div>
								</div>
							</div>
							<div class="device-chart-data">
								<div
									class="devices-chart-div conversions-chart-div {{ deviceCount }}"
									*ngFor="let config of multichartconfigurations; let i = index"
								>
									<div *ngIf="!hasData">
										<div class="map-no-data c-portlet no-data-div">{{ nodatamessage }}</div>
									</div>
									<div *ngIf="hasData">
										<app-generic-chart
											id="device-id-{{ i }}"
											[configuration]="config"
											[colorPalette]="colorPalette"
											[data]="devicesChartData"
										>
										</app-generic-chart>
									</div>
								</div>
							</div>
						</div>
						
					</div>
					
				</div>
			</div>
		</div>
	</div>
</div>
